const RightSection = () => {
  return (
    <div className="right-section">
      <img
        src="/background.png"
        className="background-img"
        alt="background Image"
      />
      <img src="./heroImg.png" className="hero-Img" alt="Main Image" />
      <img
        src="/anonymousMode.png"
        className="tag anonymous"
        alt="anonymousMode"
      />
      <img
        src="/playfulMatch.png"
        className="tag playfulMatch"
        alt="playfulMatch"
      />
      <img
        src="/focusedDisc.png"
        className="tag focusedDisc"
        alt="focusedDisc"
      />
      <img
        src="/exclusiveComm.png"
        className="tag exclusiveComm"
        alt="exclusiveComm"
      />
    </div>
  );
};

export default RightSection;
